<template>
  <div data-v-14699522="" class="cartpay">
    <div>
      <div class="conbox">
        <p class="info-title">提货信息</p>
      </div>
      <div class="conbox">
        <div class="section line flex">
          <span>•&ensp;<a style="color: grey;">提货人姓名</a></span>
          <input placeholder="请输入姓名" class="right" v-model="customName" />
        </div>
        <div class="section line flex">
          <span>•&ensp;<a style="color: grey;">提货人手机号</a></span>
          <input placeholder="请输入手机号" type="tel" class="right" v-model="customMobile" />
        </div>
        <div class="section line flex">
          <span>•&ensp;<a style="color: grey;">提货时间</a></span>
          <span class="right open"
            ><input type="text" placeholder="请选择提货时间" v-model="customDuration" />
          </span>
        </div>

        <div class="remark">
          <span style="color: grey;">备注</span> <br /><br />
          <textarea
            placeholder="您可以输入备注信息"
            class="message"
            v-model="customMemo"
          ></textarea>
        </div>
      </div>
      <div class="content">
        <section v-for="(item, index) in goodsList" :key="index">
          <div class="img">
            <img :src="item.firstPhoto" />
          </div>
          <div class="text">
            <p class="title">{{ item.proName }}</p>
            <p class="spec">规格: {{ item.specification.label }}</p>
            <div class="total">
              <span class="price">￥{{ item.price }}</span>
              <div>
                <span class="number">{{ item.goodsCount }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!---->
      <div class="clear-both"></div>
      <section class="foot">
        <p class="price">
          需要支付：<i>¥ {{ totalAmount }}</i>
        </p>
        <a href="javascript:void(0)" @click="submitOrder()" class="goto">提交订单</a>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cart',
  data() {
    return {
      goodsList: [],
      customName: '',
      customMobile: '',
      customDuration: '',
      customMemo: '',
      totalAmount: 0,
    }
  },
  created() {
    var params = this.$route.query
    var goodsId = params['goodsId']
    this.queryGoodsAll(goodsId)
  },
  methods: {
    queryGoodsAll(goodsId) {
      var that = this
      this.$queryAll(
        'ProGoods',
        { id: goodsId },
        ['id,channel,firstPhoto,specification,proName,price'],
        function(res) {
          that.$fill(that.goodsList, res['data'])
          for (var index in that.goodsList) {
            that.totalAmount += Number(that.goodsList[index]['price'])
            that.$set(that.goodsList[index], 'count', 1)
          }
        }
      )
    },
    submitOrder() {
      var that = this
      var goodsList = []
      var channel = ''
      for (var index in this.goodsList) {
        channel = this.goodsList[index].channel
        goodsList.push({
          goodsId: this.goodsList[index].id,
          count: this.goodsList[index].count,
        })
      }
      if(goodsList.length==0){
        return
      }
      var url = '/api/order/addOrderWithShop'
      if(channel=='rented'){
        url = '/api/order/addOrderWithRented'
      }
      this.$submit(
        url,
        {
          myId: this.$store.getters.userId,
          customName: this.customName,
          customMobile: this.customMobile,
          customDuration: this.customDuration,
          customMemo: this.customMemo,
          goodsList: goodsList,
        },
        function(res) {
          if (res['code'] === 1) {
            // alert('成功')
            that.$router.push({ path: '/shop/payok', query: { orderNo: res['data']['orderNo'] } })
          }
        }
      )
    },
  },
}
</script>

<style>
.cartpay .conbox {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.cartpay .info-title {
  font-size: 1.6rem;
  line-height: 5rem;
  color: grey;
}
.cartpay .conbox .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.cartpay .conbox .flex {
  display: flex;
  justify-content: space-between;
}
.cartpay .conbox .section {
  position: relative;
  font-size: 1.4rem;
  height: 4.8rem;
  line-height: 4.8rem;
  display: flex;
}
.cartpay .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.cartpay .conbox .section span {
  color: #15a892;
}
.cartpay .conbox .section .right {
  font-size: 1.4rem;
  flex: 1;
  text-align: right;
  color: #323232;
}
.cartpay .remark {
  background-color: #fff;
  font-size: 1.4rem;
  margin-left: 1rem;
  color: grey;
  margin-top: 1rem;
}
.cartpay .remark .message {
  width: 100%;
  height: 9rem;
  border: 0.1rem solid #eee;
  font-size: 1.4rem;
  color: #999;
  padding: 1rem 0.5rem 0 1rem;
}
.cartpay .content {
  margin-top: 0.9rem;
  background-color: #fff;
}
.cartpay .content section {
  height: 10rem;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  border-bottom: 1px solid #eee;
}
.cartpay .content section .img img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.3rem;
}
.cartpay .content section .text {
  width: 100%;
}
.cartpay .content section .text .title {
  height: 3.7rem;
  line-height: 2rem;
  overflow: hidden;
}
.cartpay .content section .text .spec {
  height: 1.7rem;
  font-size: 1.2rem;
  color: #999;
}
.cartpay .content section .text .total {
  display: flex;
  justify-content: space-between;
  line-height: 2.2rem;
}
.cartpay .content section .text .total .price {
  font-size: 1.6rem;
  color: #15a892;
  padding-top: 0.4rem;
  font-weight: bolder;
}
.cartpay .content section .text .total .btn1,
.cartpay .content section .text .total .btn2 {
  width: 2.4rem;
  height: 2.4rem;
  background: transparent;
  border: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}
input,
input[type='button'],
input[type='reset'],
input[type='search'],
input[type='submit'],
textarea {
  -webkit-appearance: none;
}
.cartpay .content section .text .total .number {
  width: 3.2rem;
  height: 2.4rem;
  text-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}
.cartpay .content section .text .total .btn1,
.cartpay .content section .text .total .btn2 {
  width: 2.4rem;
  height: 2.4rem;
  background: transparent;
  border: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}
.cartpay .clear-both {
  clear: both;
  height: 5rem;
}
.cartpay .foot {
  background: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  justify-content: flex-end;
}
.cartpay .foot .price {
  margin: 0 1.7rem 0 0;
}
.cartpay .foot .price i {
  color: #15a892;
  font-weight: bolder;
}
.cartpay .foot .goto {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
</style>
